/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const WarningCopyWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const WarningIconWrapper = styled.div`
  padding-right: 8px;
`;

export const WarningBranchCopyWrapper = styled.div`
  width: 100%;
`;
